import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./SubmitRequest.css";
import axios from "axios";

const SubmitRequest = () => {
  const [formData, setFormData] = useState({
    email: "",
    category: "",
    subject: "",
    description: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const response = await axios.post('/api/contact/submit-query', formData);
      if (response.status === 200) {
        setSubmitSuccess(true);
        setFormData({
          email: "",
          category: "",
          subject: "",
          description: ""
        });
      }
    } catch (error) {
      console.error("Error submitting query:", error);
      alert("Failed to submit query. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitSuccess) {
    return (
      <div className="submit-request-page">
        <div className="container">
          <nav className="breadcrumb">
            <a href="/help" className="breadcrumbs-item">Help Center</a>
          </nav>
          <div className="alert alert-success">
            <h4>Thank you for your query!</h4>
            <p>Your request has been submitted successfully. Our support team will get back to you soon.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="submit-request-page">
      <div className="container">
        <nav className="breadcrumb">
          <a href="/help" className="breadcrumbs-item">Help Center</a>
        </nav>
        <h1 className="submit-request-title">Submit Query</h1>
        <form onSubmit={handleSubmit} className="submit-request-form">
          <div className="submit-request-group">
            <label>Your email address</label>
            <input
              type="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="submit-request-group">
            <label>Category</label>
            <select 
              className="form-control"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
            >
              <option value="">Select</option>
              <option value="Tax Filling">Tax Filling</option>
              <option value="Bookscomply">Bookscomply</option>
              <option value="Company Formation">Company Formation</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <div className="submit-request-group">
            <label>Subject</label>
            <input
              type="text"
              name="subject"
              className="form-control"
              placeholder="Enter subject"
              value={formData.subject}
              onChange={handleChange}
              required
            />
          </div>
          <div className="submit-request-group">
            <label>Description</label>
            <textarea
              className="form-control"
              name="description"
              placeholder="Please enter the details of your request"
              rows="5"
              value={formData.description}
              onChange={handleChange}
              required
            ></textarea>
            <small className="form-text text-muted">
              Please enter the details of your request. A Support Manager will be with you soon!
            </small>
          </div>
          <button 
            type="submit" 
            className="btn btn-danger btn-md btn-block"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit Query'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SubmitRequest;